import { fetcher } from "helpers/fetcher";

import {
  TSearchEmploymentSecurityJobReq,
  TSearchEmploymentSecurityJobRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const searchEmploymentSecurityJob = async (
  params: TSearchEmploymentSecurityJobReq
) => {
  return await fetcher<
    TSearchEmploymentSecurityJobRes,
    TSearchEmploymentSecurityJobReq
  >(ENDPOINT.CORPORATION.SEARCH_EMPLOYMENT_SECURITY_JOB, {
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.SEARCH_EMPLOYMENT_SECURITY_JOB.version,
    },
    params: params,
  });
};

export const querySearchEmploymentSecurityJob = async (
  params: TSearchEmploymentSecurityJobReq
) => {
  return (await searchEmploymentSecurityJob(params)).data;
};

querySearchEmploymentSecurityJob._key = (
  params: TSearchEmploymentSecurityJobReq
) => [ENDPOINT.CORPORATION.SEARCH_EMPLOYMENT_SECURITY_JOB.url, params];
